<template>
  <header class="content-header bg-red">
    <div class="content-header-itens container">
      <router-link tag="a" to="/" class="content-header-itens-logo" aria-label="Ir para página inicial">
        <img src="@/assets/img/header/logo.png" alt="logo">
      </router-link>
      <div class="content-header-itens-links">
        <router-link tag="a" to="/home" class="content-header-itens-link-items">
          <p>início</p>
        </router-link>
        <router-link tag="a" to="/prizes" class="content-header-itens-link-items">
          <p>prémios</p>
        </router-link>
        <router-link tag="a" to="/faqs" class="content-header-itens-link-items">
          <p>Perguntas frequentes</p>
        </router-link>
      </div>
      <template v-if="userIsLogged">
        <router-link tag="a" to="/account" class="content-header-itens-btn d-none" >
          <img src="@/assets/img/user.png" alt="user icon" width="30" height="30">
          <p>{{ this.user.nome.substring(0, 8) + '...' }}</p>
        </router-link>
      </template>
      <template v-else>
        <div class="content-header-itens-btn d-none" @click="scrollToElement()">
          <img src="@/assets/img/user.png" alt="user icon" width="22" height="24">
          <p>Entrar</p>
        </div>
      </template>
      <div class="content-menu d-lg-none" @click="setMenuOpen(true)">
        <div class="content-menu-item">
          <span></span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      openMenuDesktop: false,

    };
  },
  props: {
    isScrolled: Boolean,
    isScrolledMobile: Boolean,
  },
  computed: {
    ...mapGetters(['isDesktop', 'activeMenuFooter', 'activeFormFloating','userIsLogged', 'user']),
  },
  methods: {
    ...mapMutations(['setActiveMenuFooter',]),
    ...mapActions(["setMenuOpen","toggleFormFixed"]),
    menuDesktopOpen(){
      if (this.openMenuDesktop){
        this.openMenuDesktop = false;
      } else {
        this.openMenuDesktop = true;
      }
    },

    scrollToElement() {
      if (this.$route.name !== 'Home') {
        localStorage.setItem('scrollToElement', true);
        window.location.href = '/home';
      }
      setTimeout(() => {
        this.$scrollTo('#login', 800, { easing: 'linear' });
      }, 1000);
    },

  },
  
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>